import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    computed: {
        isAgency() {
            return this.organization.is_agency === true;
        },

        sortedBillingSources() {
            const isAchPaymentsActive = this.organizationSettings.find(
                (setting) => setting?.key === 'ach_payments'
            )?.settings?.active;

            let billingSources = this.billingSourcesSimple;

            if (isAchPaymentsActive) {
                billingSources = [...this.billingSourcesAch, ...this.billingSourcesSimple];
            }

            const primary = billingSources.findIndex((o) => o.primary);
            const sources = [
                ...billingSources.slice(0, primary),
                ...billingSources.slice(primary + 1),
            ].sort((a, b) => {
                const monthA = `${a.exp_month < 10 ? '0' : ''}${a.exp_month}`;
                const monthB = `${b.exp_month < 10 ? '0' : ''}${b.exp_month}`;
                const expA = `${a.exp_year}${monthA}`;
                const expB = `${b.exp_year}${monthB}`;

                if (expA < expB) {
                    return -1;
                }

                if (expA > expB) {
                    return 1;
                }

                return 0;
            });

            if (primary !== -1) {
                sources.unshift(billingSources[primary]);
            }

            return sources;
        },

        ...mapState(stores.User, ['user', 'userPermissions', 'userSettings']),
        ...mapState(stores.Organization, ['organizationSettings', 'organization']),
        ...mapState(stores.Subscriptions, ['subscription']),
        ...mapState(stores.BillingSources, [
            'billingSources',
            'billingSourcesSimple',
            'billingSourcesAch',
            'billingSourcesLoading',
            'billingSourcesError',
        ]),
        ...mapState(stores.Number, ['hasNumber']),
    },

    mounted() {},
};
